import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService, private cookieService: CookieService) {
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Clone the request object

        let headers = req.headers;

        // Authorization Header
        if (this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken)) {
            headers = headers.set('Authorization', 'Bearer ' + this._authService.accessToken);
        }

        // Handle XSRF Token for state-changing operations
        const stateChangingMethods = ['POST', 'PUT', 'DELETE', 'PATCH'];
        if (stateChangingMethods.includes(req.method)) {
            const xsrfToken = this.cookieService.get('XSRF-TOKEN-REQUEST');
            if (xsrfToken) {
                headers = headers.set('X-XSRF-TOKEN', xsrfToken);
            } else {
                console.warn('XSRF Token missing for state-changing request');
            }
        }

        let isMicrosoftRequest = false;
        const allowedHosts = new Set(['graph.microsoft.com', 'login.microsoftonline.com']);

        try {
            const parsedUrl = new URL(req.url);
            isMicrosoftRequest = allowedHosts.has(parsedUrl.hostname.toLowerCase());
        } catch (e) {}

        const newReq = req.clone({
            withCredentials: !isMicrosoftRequest,
            headers: headers
        });

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {

                // Catch "401 Unauthorized" responses
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app
                    location.reload();
                }
                return throwError(() => new Error(error));

            })
        );
    }
}
